import React, { useEffect, useRef, useState } from 'react'
import { Button, Table, Tag, Modal, Popover, Switch, message, Dropdown, Space, Input} from 'antd'
import axios from 'axios';
import { EditOutlined, DeleteOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ExclamationCircleFilled } from '@ant-design/icons';
import AddUserForm from '../../../components/user-manage/AddUserForm';
import UpdateUserForm from '../../../components/user-manage/UpdateUserForm';
import dayjs from 'dayjs';
import moment from 'moment';
import Highlighter from 'react-highlight-words';

const { confirm } = Modal;

export default function UserList() {
  const addForm = useRef(null)
  const updateForm = useRef(null)
  const [dataSource, setDataSource] = useState([]);
  const [showResigned, setShowResigned] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [idAddOpen, setisAddOpen] = useState(false);
  const [isUpdateOpen, setisUpdateOpen] = useState(false);
  const [isUpdateDisable, setisUpdateDisable] = useState(false);
  const [roleList, setroleList] = useState([]);
  const [regionList, setregionList] = useState([]);
  const [currentUpdateData, setcurrentUpdateData] = useState({});
  const [groupPermission, setGroupPermission] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const {roleId, region, username} = {}



  useEffect(()=>{
    axios.get('/api/group-permission').then(res=>{
      setGroupPermission(res.data.filter(item=>item.enable === 1))
    }).catch(err=>{
      console.error('group permission取得失敗',err)
    })
  },[])

  useEffect(()=>{
    axios.get('/api/user').then(res=>{
      setDataSource(res.data)
    }).catch(err=>{
      console.error('user資料取得失敗',err)
    })
  },[])

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            搜尋
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重設
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: '員工編號',
      dataIndex: 'employee_id',
      sorter: (a, b) => a.employee_id - b.employee_id,
      defaultSortOrder: 'ascend', // 預設升序排序
      ...getColumnSearchProps('employee_id'),
    },
    {
      title: '中文姓名',
      dataIndex: 'chinese_name',
      ...getColumnSearchProps('chinese_name'),
    },
    {
      title: '英文姓名',
      dataIndex: 'name',
      sorter: (a, b) => a.name - b.name,
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      ...getColumnSearchProps('email'),
    },
    {
      title: '到職日期',
      dataIndex: 'date_of_employment',
      sorter: (a, b) => moment(a.date_of_employment).unix() - moment(b.date_of_employment).unix(),
    },
    {
      title: '離職日期',
      dataIndex: 'date_of_resignation'
    },
    {
      title: '權限群組',
      dataIndex: 'group_permission_id',
      filters: [
        ...groupPermission
          .filter(item=>item.enable===1)
          .map(item=>({
            text: item.name,
            value: item.id
          })),
      ],
      onFilter: (value,item)=>{
        return item.group_permission_id === value
      },
      render:(value)=>{
        let permissioData = groupPermission.find(item=>item.id === value)
        return <b>{permissioData?.name}</b>
      }
    },
    {
      title: '帳戶狀態',
      dataIndex: 'enable',
      render: (value,item)=>{
        return <Switch checked={value} disabled={item.date_of_resignation!== null || item.employee_id === 'E0000'} onChange={()=>handleUserStateChange(item)}></Switch>
      }
    },
    {
      title: '操作',
      render:(item)=>{
        return <div>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={()=>{handleUserUpdate(item)}}
            disabled={item.employee_id === 'E0000'}
          />
        </div>
      }
    },
  ];

  const addFormOK = () => {
    addForm.current.validateFields().then(value=>{
      let date_of_employment = value.dateOfEmployment.format('YYYY/MM/DD').toString()
      //從post到後端。生成ID後再設定dataSource
      axios.post('/api/user', {
        ...value,
        enable: 1,
        date_of_employment
      }).then(res=>{
        setisAddOpen(false)
        addForm.current.resetFields()
        setDataSource([
          ...dataSource,
          {...res.data}
        ])
        success('使中者新增成功')
      }).catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else{
          error('錯誤，請洽管理員')
          console.error(err)
        }
      })
    }).catch(err=>{
      error('請輸入完整員工資訊')
    })
  }

  //往後端傳送update user資料請求
  const updateUserData = (data)=>{
    axios.patch(`/api/user/${data.id}`,data)
    .then(res=>{
      setDataSource(dataSource.map(item=>{
        if(item.id === data.id){
          return res.data
        }
        return item;
      }))
      success('使中者編輯成功')
    }).catch(err=>{
      if(typeof err.response.data.errors === 'object' ){
        let error_meaage = Object.values(err.response.data.errors).join(' ')
        error(error_meaage)
      }else{
        error('錯誤，請洽管理員')
        console.error(err)
      }
    })
  }

  const handleUserStateChange = (item) => {
    let newUserItem = {...item}
    newUserItem.enable = !newUserItem.enable
    updateUserData(newUserItem)
  }

  const handleUserUpdate = (item) => {
    setcurrentUpdateData(item)
    item.dateOfEmployment = dayjs(item.date_of_employment, 'YYYY/MM/DD')
    if(item.date_of_resignation !== null){
      item.dateOfResignation = dayjs(item.date_of_resignation, 'YYYY/MM/DD')
    }
    Promise.resolve()
    .then(()=>{setisUpdateOpen(true)})
    .then(()=>{updateForm.current.setFieldsValue(item)})

  }

  const updateFormOK = () => {
    updateForm.current.validateFields().then(value=>{
      let date_of_employment = value.dateOfEmployment.format('YYYY/MM/DD').toString()
      let date_of_resignation = null;
      if(value.dateOfResignation !== null && value.dateOfResignation !== undefined){
        date_of_resignation = value.dateOfResignation.format('YYYY/MM/DD').toString()
      }
      updateUserData({
        id:currentUpdateData.id,
        ...value,
        enable: currentUpdateData.enable,
        date_of_employment,
        date_of_resignation
      })
      setisUpdateOpen(false)
      updateForm.current.resetFields()

      //TODO:能否用promist方式取出updateUserData 的結果？
    }).catch(err=>{
      error('請輸入完整員工資訊')
    })
  }

  const filteredDataSource = showResigned
    ? dataSource
    : dataSource.filter(item => item.date_of_resignation === null);

  const filteredColumn = showResigned
    ? columns
    : columns.filter(item=>item.dataIndex !== 'date_of_resignation')
  const changeResignedVisiable = ()=> {
    setShowResigned(!showResigned);
  }

  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  const items = [
    {
      label: (
        <Button onClick={changeResignedVisiable}>{showResigned?'隱藏離職人員':'顯示離職人員'}</Button>
      ),
      key: '0',
    },
  ];

  return (
    <div>
      {contextHolder}
      <Button type="primary" onClick={()=>setisAddOpen(true)}>新增員工</Button>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

        <Dropdown

          menu={{
            items,
          }}
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              列表功能
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      </div>

      <p></p>
      <Table
        dataSource={filteredDataSource}
        columns={filteredColumn}
        pagination={{pageSize: 50}}
        rowKey='id'
      />
      {/* TODO: open有錯字  */}
      <Modal
        open={idAddOpen}
        title="新增員工"
        okText="確定"
        cancelText="取消"
        onCancel={()=>{setisAddOpen(false)}}
        onOk={() => {addFormOK()}}
      >
        <AddUserForm groupPermission={groupPermission} ref={addForm}/>
      </Modal>
      <Modal
        open={isUpdateOpen}
        title="編輯員工"
        okText="更新"
        cancelText="取消"
        onCancel={()=>{setisUpdateOpen(false)}}
        onOk={() => {updateFormOK()}}
      >
        {/* <UserForm isUpdate={true} regionList={regionList} roleList={roleList} ref={updateForm} isUpdateDisable={isUpdateDisable}/> */}
        <UpdateUserForm groupPermission={groupPermission} ref={updateForm}/>
      </Modal>
    </div>
  )
}
